export class EstadoRequest {
    estado: number;
    id: number;
    tipo: string;

}
